/* globals data, onlyOneCatcher, serverParams */
import { playerDisplayFnById } from '../utils/bat-tracking-table-helpers'
import getDynamicAggregateFirstHeaders from '../utils/dynamic-aggregate-first-headers'
import getGroupedHeaders from '../utils/get-grouped-headers'

const { guff } = require('bam-node-baseball-savant/utils/guff')
const { getPitchName } = require('bam-node-baseball-savant/utils/pitch-names')

const runValArray = data.map((d) => d.rv_tot)
const [runValMax, runValMin] = [
    Math.ceil(Math.max(...runValArray)) + 0,
    Math.floor(Math.min(...runValArray)) + 0,
]
const highlightRange = [runValMin, 0, runValMax].sort(
    (a, b) => Number(a) - Number(b)
)

const showDisclaimer = ['batter', 'batting-team', 'pitcher'].includes(
    serverParams.type
)

function getBucketHeader(val) {
    if (Number(val) < 0) {
        return `${Math.abs(val + 1)}-${Math.abs(val)} inches<br />inside zone`
    }
    return `${val}-${val + 1} inches<br />outside zone`
}

export const groupHeaders = getGroupedHeaders(serverParams.secondaryGroupBy)

const link = '?stat=statcast-r-catching-mlb'
const firstHeaders = getDynamicAggregateFirstHeaders(serverParams.type, link)

export const headers = [
    ...firstHeaders,

    {
        name: 'Shadow<br />Pitches',
        field: 'pitches_shadow',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
    },
    {
        name: 'Catcher<br />Framing<br />Runs',
        field: 'rv_tot',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_tot',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_11',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_11',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_12',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_12',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_13',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_13',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_14',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_14',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_16',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_16',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_17',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_17',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_18',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_18',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_19',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_19',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
]

export const headersDefault = [
    ...firstHeaders,

    {
        name: 'Pitches',
        field: 'pitches',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data align-center border-left`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
    },
    {
        name: 'Catcher<br />Framing<br />Runs',
        field: 'rv_tot',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Shadow<br />Strike<br />%',
        field: 'pct_tot',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_shadow_top',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_shadow_top',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_shadow_top',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_shadow_bot',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_shadow_bot',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_shadow_bot',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_14',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_14',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_14',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_16',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_16',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_16',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_heart',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_heart',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_heart',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
    {
        name: '#',
        field: 'pitches_chwa',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_count'),
        toolTip: '# of Pitches',
    },
    {
        name: 'Framing<br />Runs',
        field: 'rv_chwa',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
        highlight: highlightRange,
    },
    {
        name: 'Strike<br />%',
        field: 'pct_chwa',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pitch_percent', { removePercent: true }),
    },
]

const isLeague = serverParams.type === 'league'
const initColspanLarge = isLeague ? 3 : 4

export const secondaryHeaders = [
    {
        name: showDisclaimer
            ? `Note: For batter and pitcher tables,<br />
        these values show the framing value<br />
        of all <em>catchers</em> while that batter is at the<br />
        plate or that pitcher is on the mound.`
            : '',
        colspan: initColspanLarge + groupHeaders.length,
        headerClass: 'th-name-header',
    },
    {
        name: 'Shadow Zone',
        colspan: 2,
        headerClass: 'th-title-header border-left border-right',
    },
    {
        name: 'Zone 11',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 12',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 13',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 14',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 16',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 17',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 18',
        colspan: 2,
        headerClass: 'th-title-header',
    },
    {
        name: 'Zone 19',
        colspan: 2,
        headerClass: 'th-title-header border-right',
    },
]

const initColspanDefault = isLeague ? 2 : 3
export const secondaryHeadersDefault = [
    {
        name: showDisclaimer
            ? `Note: For batter and pitcher tables,<br />
            these values show the framing value<br />
            of all <em>catchers</em> while that batter is at the<br />
            plate or that pitcher is on the mound.`
            : '',
        colspan: initColspanDefault + groupHeaders.length,
        headerClass: 'th-name-header',
    },
    {
        name: 'Totals',
        colspan: 3,
        headerClass: 'th-title-header border-left border-right',
    },
    {
        name: 'Shadow - Top',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Shadow - Bottom',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Shadow - Left',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Shadow - Right',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Heart',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Chase / Waste',
        colspan: 3,
        headerClass: 'th-title-header',
    },
]

export const allPitchHeaders = [
    {
        name: 'Date',
        field: 'game_date',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => val.slice(0, 10),
    },
    // {
    //     name: 'Inning',
    //     field: 'event_inning',
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data align-center',
    // },
    // {
    //     name: 'Outs',
    //     field: 'outs',
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data align-center',
    // },
    {
        name: 'Count',
        field: 'pre_ball_count',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val, { pre_strike_count }) => `${val}-${pre_strike_count}`,
    },
    {
        name: 'Catcher',
        field: 'f2_name_display_first_last',
        headerClass: `th-component-header align-left th-vertical-bottom`,
        fieldClass: `tr-data align-left`,
        defaultSortDir: 'asc',
        displayFn: (val, { fielder_2 }) =>
            playerDisplayFnById(val, fielder_2, { firstInit: true }),
    },
    {
        name: 'Pitcher',
        field: 'p_name_display_first_last',
        headerClass: `th-component-header align-left th-vertical-bottom`,
        fieldClass: `tr-data align-left`,
        defaultSortDir: 'asc',
        displayFn: (val, { pitcher }) =>
            playerDisplayFnById(val, pitcher, { firstInit: true }),
    },
    {
        name: 'Batter',
        field: 'b_name_display_first_last',
        headerClass: `th-component-header align-left th-vertical-bottom`,
        fieldClass: `tr-data align-left`,
        defaultSortDir: 'asc',
        displayFn: (val, { player_at_bat }) =>
            playerDisplayFnById(val, player_at_bat, { firstInit: true }),
    },
    {
        name: 'Result',
        field: 'event_type',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val, { pre_ball_count, pre_strike_count }) => {
            if (val === 'ball' || val === 'blocked_ball') {
                if (pre_ball_count === 3) {
                    return 'Walk'
                }
                return 'Ball'
            }
            if (pre_strike_count === 2) {
                return 'Strikeout'
            }
            return 'Strike'
        },
    },
    // {
    //     name: 'Framing<br />Runs',
    //     field: 'catcher_framing_runs',
    //     type: 'number',
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data align-center',
    //     displayFn: (val) => guff(val, 'run_value_zone'),
    // },
    {
        name: 'Dist. off<br />Edge (inches)',
        field: 'edge_dist_calc',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => guff(Math.abs(val), 'strike_zone_distance'),
    },
    {
        name: 'Called<br />Strike Prob.',
        field: 'called_strike_prob',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => {
            if (val === 0) {
                return '< 0.1%'
            }
            if (Math.round(val * 100) === 0) {
                return guff(val, 'pitch_percent')
            }
            if (val === 1) {
                return '> 99%'
            }
            return guff(val, 'cs_percent')
        },
    },
    {
        name: '',
        field: 'entity_id',
        headerClass:
            'th-component-header align-center th-vertical-bottom video-col cursor-initial',
        fieldClass: 'tr-data video-col',
        type: 'number',
        sortable: false,
        displayFn: (value, { play_id }) => `
                    <a href="/sporty-videos?playId=${play_id}" target="_BLANK">
                        <img src="/site-core/images/video.png" style="margin-right: 4px; width: 25px; height: 13px; cursor: pointer;">
                    </a>
                   `,
    },
]

export const vizTableHeaders = [
    {
        name: 'Inches from<br />Zone Edge',
        field: 'bucket',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => getBucketHeader(val),
    },
    {
        name: 'Called Strike<br />Percent',
        field: 'leftVal',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val, { rightVal }) => {
            if (val > rightVal) {
                return `<strong><u>${guff(val, 'cs_percent')}</u></strong>`
            }
            return guff(val, 'cs_percent')
        },
    },
    {
        name: 'Called Strike<br />Percent',
        field: 'leagueVal',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) =>
            `<div style="font-style: italic;">${guff(val, 'cs_percent')}</div>`,
    },
    {
        name: 'Called Strike<br />Percent',
        field: 'rightVal',
        type: 'number',
        headerClass: `th-component-header align-center th-vertical-bottom ${
            onlyOneCatcher ? 'hidden' : ''
        }`,
        fieldClass: `tr-data align-center  ${onlyOneCatcher ? 'hidden' : ''}`,
        displayFn: (val, { leftVal }) => {
            if (val > leftVal) {
                return `<strong><u>${guff(val, 'cs_percent')}</u></strong>`
            }
            return guff(val, 'cs_percent')
        },
    },
]

export function getGroupedTableHeaders(buttonType) {
    const currType = serverParams.type
    const groupedHeaders = []

    if (currType === 'catcher' || buttonType === 'catcher') {
        groupedHeaders.push({
            name: 'Catcher',
            field: 'f2_name_display_first_last',
            headerClass: `th-component-header align-left th-vertical-bottom`,
            fieldClass: `tr-data align-left`,
            defaultSortDir: 'asc',
            displayFn: (val, { fielder_2 }) =>
                playerDisplayFnById(val, fielder_2),
        })
    }

    if (currType === 'pitcher' || buttonType === 'pitcher') {
        groupedHeaders.push({
            name: 'Pitcher',
            field: 'p_name_display_first_last',
            headerClass: `th-component-header align-left th-vertical-bottom`,
            fieldClass: `tr-data align-left`,
            defaultSortDir: 'asc',
            displayFn: (val, { pitcher }) => playerDisplayFnById(val, pitcher),
        })
    }

    if (currType === 'batter' || buttonType === 'batter') {
        groupedHeaders.push({
            name: 'Batter',
            field: 'b_name_display_first_last',
            headerClass: `th-component-header align-left th-vertical-bottom`,
            fieldClass: `tr-data align-left`,
            defaultSortDir: 'asc',
            displayFn: (val, { player_at_bat }) =>
                playerDisplayFnById(val, player_at_bat),
        })
    }

    if (buttonType === 'pitchtype') {
        groupedHeaders.push({
            name: 'Pitch Type',
            field: 'api_pitch_type_group03',
            headerClass: `th-component-header align-left th-vertical-bottom`,
            fieldClass: `tr-data align-left`,
            displayFn: (val) => {
                if (!val) {
                    return '<em>Other</em>'
                }
                return `<span
                        style="display: inline-block; margin: 2px 0"
                        class="search-pitch-label search-pitch-label-${val}"
                        title="${getPitchName(val)}"
                    >
                        ${val}
                    </span> &nbsp;&nbsp; ${getPitchName(val)}`
            },
        })
    }

    groupedHeaders.push({
        name: 'Pitches',
        field: 'tot_pitches',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => guff(val, 'pitch_count'),
    })

    groupedHeaders.push({
        name: 'Framing Runs',
        field: 'catcher_framing_runs',
        type: 'number',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val) => guff(val, 'run_value_zone'),
    })

    return groupedHeaders
}

function getVizSecondary(id, name) {
    let imageHtml = `
                <img
                    height="60"
                    width="60"
                    onError="this.onerror=null;this.src='https://img.mlbstatic.com/mlb-photos/image/upload/w_60,d_people:generic:headshot:silo:current.png,q_auto:best,f_auto/v1/people/generic/headshot/silo/current';"
                    src="https://img.mlbstatic.com/mlb-photos/image/upload/w_60,d_people:generic:headshot:silo:current.png,q_auto:best,f_auto/v1/people/${id}/headshot/silo/current"
                />
            `

    imageHtml += `<br />${name}`

    return imageHtml
}

export function getSecondaryVizTableHeaders(
    leftID,
    rightID,
    leftName,
    rightName
) {
    const secondaryVizHeaders = [
        {
            name: '',
            colspan: 1,
            headerClass: 'th-title-header',
        },
        {
            name: getVizSecondary(leftID, leftName),
            colspan: 1,
            headerClass: 'th-title-header',
        },
        {
            name: '<div style="font-style: italic; color: red;">League</div>',
            colspan: 1,
            headerClass: 'th-title-header th-vertical-bottom',
        },
        {
            name: getVizSecondary(rightID, rightName),
            colspan: 1,
            headerClass: `th-title-header  ${onlyOneCatcher ? 'hidden' : ''}`,
        },
    ]

    return secondaryVizHeaders
}
